module.exports = __webpack_public_path__ + "static/ios-1cbfccc920d3edee698495af8441c007.svg";